import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ROLE_REDIRECTS = {
  super_admin: "/super-admin",
  admin: "/admin/dashboard",
  counter: "/count",
  count_assistant: "/count",
};

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    const redirect = ROLE_REDIRECTS[user.role] || "/";
    return <Navigate to={redirect} replace />;
  }

  return children;
}
